import type maplibregl from 'maplibre-gl';

// The renderer, hooks and layer manager all type against the lazily-loaded
// MapLibre module.
export type MapEngineModule = typeof maplibregl;

let maplibrePromise: Promise<MapEngineModule> | null = null;

// maplibre-gl is loaded lazily so it only ships to the main thread when a
// map actually renders. Its stylesheet rides the same dynamic chunk.
export function loadMapLibreEngine(): Promise<MapEngineModule> {
  maplibrePromise ??= Promise.all([
    import('maplibre-gl'),
    import('pmtiles'),
    import('maplibre-gl/dist/maplibre-gl.css'),
  ])
    .then(([lib, pmtiles]) => {
      const maplibre = (lib.default ?? lib) as unknown as MapEngineModule & {
        addProtocol: (
          customProtocol: string,
          loadFn: InstanceType<typeof pmtiles.Protocol>['tile']
        ) => void;
      };
      maplibre.addProtocol('pmtiles', new pmtiles.Protocol().tile);
      return maplibre;
    })
    .catch((error: unknown) => {
      // A failed chunk fetch (stale deploy, offline) must not poison the
      // memo — otherwise every map for the rest of the session reuses the
      // rejected promise and can never recover.
      maplibrePromise = null;
      throw error;
    });
  return maplibrePromise;
}
